import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Update from "../../table/Update";
import WaterCharges from "./WaterCharges";
import { format } from "date-fns";

const UpdateWaterCharges = () =>{
    const {register,handleSubmit,setValue,formState:{errors}} = useForm();
    const {Id} = useParams();
    const navigate = useNavigate();
    const [distributaryZone,setDistributaryZone] = useState([]);
    const [ data,setData] = useState<any>([])
    
    const initialData ={
         EffectiveFrom:data?.effectiveFrom,
         UnitPrice : data?.unitPrice
    }
   
    useEffect(() => {
      const fetchWaterCharges = async () => {
         try{
           const response = await ApiService.axiosApi(`/watercharges/${Id}`,{
              method: 'GET',
           });
           if(response.success){
           
            setData(response.data)
              
           }
         }catch(error: any){
          toast.error(error.message);
         }
      }
      if(Id) fetchWaterCharges();
    }, [Id, setValue, navigate]);
  
      
      const onSubmit = async (data :any) => {
        try{
        
          const response = await ApiService.axiosApi(`/watercharges/${Id}`,{
            method: 'PUT',
            data: data,
          })
          if(response.success){
            toast.success("User Charges updated successfully");
            navigate(-1);
          }else{
            toast.error(response.message);
          }
            
        }catch(error: any){
          toast.error(error.message);
        }
      }
  
    return(
        <>
        <Update
           title={'Update User Charges'}
           parentTitle = {'User Charges'}

           fields={
             [
                {
                  name:"EffectiveFrom",
                  label : "EffectiveFrom",
                  type : "dateTime"
                },
                {
                  name: "UnitPrice",
                  label: "Unit Price", 
                  type:'text'        
                        }
             ]
           }
           onSubmit={onSubmit}
           initialData ={initialData}
         />
        </> 
    )
}

export default UpdateWaterCharges;